module.exports = __webpack_public_path__ + "media/images/view-more-news-6e717e0e4777baf68735ffb67d37b862.png";